import { cn } from "@repo/utils";
import { Plus } from "lucide-react";

export default function CatalogueDennosFormationRSE() {
  return (
    <div>
      <div className={cn("mb-8 flex items-center space-x-4")}>
        <div className={cn("w-4/5 rounded-xl bg-teal-300 p-2")}>
          <div className={cn("text-2xl font-extrabold")}>
            La Responsabilité Sociétale des Entreprises (RSE): définir une
            stratégie gagnante
          </div>
          <div className={cn("text-lg text-gray-500")}>
            Identifier de nouvelles opportunités pour votre entreprise
          </div>
        </div>
        <div>
          <img
            src="/logos/demos.png"
            alt="logo_dennos"
            width={300}
            height={200}
          />
        </div>
      </div>
      <div className={cn("flex space-x-10")}>
        <div className={cn("w-1/3 space-y-10")}>
          <div className={cn("flex flex-col space-y-4 rounded-lg bg-teal-300 p-4")}>
            <div>
              <div className={cn("text-3xl font-extrabold")}>2 jours (14h)</div>
              <div className={cn("text-lg font-extrabold")}>
                Présentiel ou à distance
              </div>
              <div className={cn("flex space-x-2")}>
                <Plus />
                <div>accès au LearningHub</div>
              </div>
            </div>
            <div className={cn("h-[2px] rounded-full bg-gray-500")}></div>
            <div className={cn("text-3xl font-extrabold")}>1 425 € HT</div>
            <div className={cn("h-[2px] rounded-full bg-gray-500")}></div>
            <div className={cn("flex items-center")}>
              <div className={cn("text-xl font-extrabold")}>Niveau</div>
              <div>: Fondamental</div>
            </div>
            <div className={cn("h-[2px] rounded-full bg-gray-500")}></div>
            <div className={cn("text-xl font-extrabold")}>
              Réf. <span className={cn("text-3xl")}>6442</span>
            </div>
          </div>
          <div className={cn("relative rounded-lg border-4 border-teal-300")}>
            <div
              className={cn(
                "absolute flex -translate-y-7 translate-x-3 items-center bg-white px-2 text-3xl font-bold text-teal-400"
              )}
            >
              <div>Le </div>
              <div>
                <Plus width={50} height={50} />
              </div>
            </div>
            <ul className={cn("list-disc p-4 pl-6")}>
              <li>
                Une vision globale et des outils opérationnels pour définir une
                stratégie RSE.
              </li>
              <li>{`Une étude de cas assure l'appropriation des concepts abordés. La construction d'un plan d'actions personnel.`}</li>
            </ul>
          </div>
        </div>
        <div className={cn("flex w-2/3 flex-col")}>
          <div className={cn("mt-6 text-2xl font-semibold text-teal-400")}>
            Objectifs professionnels
          </div>
          <div>
            <ul className={cn("list-disc pl-6")}>
              <li>{`S'approprier les concepts et les enjeux de la Responsabilité Sociétale des Entreprises (RSE).`}</li>
              <li>Elaborer une stratégie de RSE concrète, adaptée.</li>
            </ul>
          </div>
          <div className={cn("mt-6 text-2xl font-semibold text-teal-400")}>
            Evaluation
          </div>
          <div>
            <ul className={cn("list-disc pl-6")}>
              <li>
                Evaluation des compétences acquises via un questionnaire en
                ligne intégrant des mises en situation.
              </li>
            </ul>
          </div>
          <div className={cn("mt-6 text-2xl font-semibold text-teal-400")}>
            Pour qui
          </div>
          <div>
            <ul className={cn("list-disc pl-6")}>
              <li>
                Responsable RSE et/ou développement durable, manager,
                consultant, connaissant les bases du développement durable et de
                la RSE.
              </li>
            </ul>
          </div>
          <div className={cn("mt-6 text-2xl font-semibold text-teal-400")}>
            Prérequis
          </div>
          <div>
            <ul className={cn("list-disc pl-6")}>
              <li>Aucun</li>
            </ul>
          </div>
          <div className={cn("my-6 flex items-center space-x-4")}>
            <div className={cn("text-2xl font-semibold text-teal-400")}>
              Programme
            </div>
            <div className={cn("h-[2px] w-full bg-teal-400")}></div>
          </div>
          <div className={cn("mt-4 text-lg font-semibold text-teal-400")}>
            1 - Développement Durable et Responsabilité Sociétale des
            Entreprises (RSE) : concepts et enjeux
          </div>
          <div>
            <ul className={cn("list-disc pl-6")}>
              <li>Enjeux et définition du développement durable.</li>
              <li>
                Les points clés liés à la règlementation française et
                européenne.
              </li>
              <li>{`Principes de la Responsabilités Sociétales des Entreprises. L'approche risques/opportunités.`}</li>
            </ul>
          </div>
          <div className={cn("mt-4 text-lg font-semibold text-teal-400")}>
            2 - Les changements de références induits par la RSE
          </div>
          <div>
            <ul className={cn("list-disc pl-6")}>
              <li>{`Le changement de l'échelle temps, de la référence espace, d'indicateurs de performance.`}</li>
              <li>La prise en compte des parties prenantes.</li>
              <li>
                Les nouveaux modèles économiques (économies de fonctionnalité,
                collaborative, circulaire...).
              </li>
              <li>{`La RSE : source d'innovation, de nouveaux business.`}</li>
              <li>{`L'impact sur les métiers (Achats, RH, Marketing, Com, Logistique...).`}</li>
            </ul>
          </div>
          <div className={cn("mt-4 text-lg font-semibold text-teal-400")}>
            3 - Construire sa stratégie RSE : un outil, des étapes
          </div>
          <div>
            <ul className={cn("list-disc pl-6")}>
              <li>{`L'ISO 26000.`}</li>
              <li>Les étapes incontournables.</li>
              <li>{`Le diagnostic interne et externe pour identifier les enjeux autour du cycle d'activité.`}</li>
              <li>Définir ses enjeux prioritaires, la matrice de matérialité.</li>
              <li>Formuler sa stratégie RSE.</li>
              <li>{`Déployer sa stratégie: être structuré dans l'action.`}</li>
              <li>{`Mesurer l'efficacité des actions.`}</li>
              <li>
                Communiquer pour rendre visibles les progrès sans tomber dans le
                green washing.
              </li>
            </ul>
          </div>
          <div className={cn("mt-4 text-lg font-semibold text-teal-400")}>
            4 - Accompagner le changement
          </div>
          <div>
            <ul className={cn("list-disc pl-6")}>
              <li>Mettre une organisation dédiée.</li>
              <li>Mobiliser les acteurs.</li>
              <li>Communiquer et former en interne.</li>
            </ul>
          </div>
        </div>
      </div>
      <div className={cn("my-6 h-[2px] w-full bg-teal-400")}></div>
      <div className={cn("flex items-center space-x-4")}>
        <div className={cn("text-3xl font-extrabold text-teal-400")}>
          Dates :
        </div>
        <div className={cn("flex items-center space-x-2")}>
          <div>Retrouvez les dates et les places disponibles en tapant</div>
          <div className={cn("font-bold")}>demos.fr/6442</div>
        </div>
      </div>
      <div className={cn("flex space-x-1")}>
        <div>Formation propsée à</div>
        <div className={cn("font-semibold text-black")}> Paris, </div>
        <div className={cn("font-semibold text-red-600")}>Classe à distance</div>
      </div>
    </div>
  );
}

CatalogueDennosFormationRSE.title = `Catalogue Demos Formation RSE`;
